<script>
import { mapGetters } from 'vuex'
import Layout from '@layouts/main.vue'
import Translatable from '@src/mixins/translatable'
import SeoMixin from '@src/mixins/seo'

import bgImage from '@assets/images/404-background.png'

export default {
  components: { Layout },
  mixins: [Translatable, SeoMixin],
  data() {
    return {
      bgImage,
    }
  },
  computed: {
    ...mapGetters('translations', ['currentLanguage']),

    seoEntity() {
      return {
        isStatic: true,
        seo: {
          metaTitle: { [this.currentLanguage]: '404 - Page Not Found' },
          metaDescription: { [this.currentLanguage]: 'Page not found' },
          markupType: 'WebPage',
        },
      }
    },
  },
  metaInfo() {
    return {
      title: '404 - Page Not Found',
      meta: [{ name: 'robots', content: 'noindex' }],
    }
  },
}
</script>

<template>
  <Layout>
    <div
      class="not-found-wrapper"
      :style="{ backgroundImage: `url(${bgImage})` }"
    >
      <div class="container content">
        <h1 class="error-code">404</h1>

        <h2 class="title">
          {{ getTranslatedContent('PAGE_404_TITLE') || 'Oops! Page not found' }}
        </h2>

        <p class="subtitle">
          {{
            getTranslatedContent('PAGE_404_TEXT') ||
            'The page you are looking for does not exist.'
          }}
        </p>

        <router-link :to="$l('home')" class="home-btn">
          <button class="button">
            {{ getTranslatedContent('PAGE_404_BTN') || 'Go Home' }}
          </button>
        </router-link>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.not-found-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // background: rgba(0, 0, 0, 0);
  }
}

.content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Open Sans Bold', sans-serif;
}

.error-code {
  font-size: 220px;
  font-weight: bold;
  margin: 0;
  line-height: 1;
  color: #ffffff;
  font-family: 'Open Sans Bold', sans-serif;
}

.title {
  font-size: 36px;
  font-weight: bold;
  margin: 20px 0 10px;
  text-transform: uppercase;
  font-family: 'Open Sans Bold', sans-serif;
}

.subtitle {
  font-size: 18px;
  max-width: 600px;
  margin-bottom: 40px;
  line-height: 1.5;
  font-family: 'Open Sans Bold', sans-serif;
}

.home-btn {
  text-decoration: none;

  .button {
    background: $orange;
    font-family: 'Open Sans Bold', sans-serif;
    color: white;
    border: none;
    padding: 15px 40px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    text-transform: uppercase;
    // transition: background 0.3s;

    &:hover {
      background: $hover-orange;
    }
  }
}
::v-deep .footer {
  margin-top: 0 !important;
}

@media (max-width: 768px) {
  .error-code {
    font-size: 80px;
  }
  .title {
    font-size: 28px;
  }
  .subtitle {
    font-size: 16px;
  }
}
</style>
